import { render } from "./ClientOrderStatistic.vue?vue&type=template&id=14538184&scoped=true"
import script from "./ClientOrderStatistic.vue?vue&type=script&lang=js"
export * from "./ClientOrderStatistic.vue?vue&type=script&lang=js"

import "./ClientOrderStatistic.vue?vue&type=style&index=0&id=14538184&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14538184"]])

export default __exports__